import script from "./PostItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PostItem.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__